import Constants from '../constants/AllFlightsConstants';
import AllFlightsRemoting from '../../remoting/AllFlightsRemoting';
import StatusCodes from '../../model/StatusCodes';

/**
 *
 * @param {*} type - type constant (string)
 * @param {*} data - object, list or string
 */
function dispatchToReducer (type, data) {
  return {
    type: type,
    data: data,
  };
}

/**
 * getSessionToken called on client getting session token and saving it to cookie
 */
export function getAllFlights (reservationId, routeId) {
  return dispatch => {
    dispatch(dispatchToReducer(Constants.ALL_FLIGHTS_REQUEST));
    AllFlightsRemoting.getAllFlights(reservationId, routeId)
      .then(response => {
        if (response && response.status === StatusCodes.UNKNOWN_ERROR) {
          return dispatch(dispatchToReducer(Constants.ALL_FLIGHTS_FAILURE, response));
        }
        if (response && response.status === StatusCodes.OK) {
          let allFlights = [
            {
              routeId,
              flights: response.data,
            },
          ];
          let secondRoute = routeId === '1' ? '2' : '1';
          AllFlightsRemoting.getAllFlights(reservationId, secondRoute)
            .then(response => {
              if (response && response.status === StatusCodes.UNKNOWN_ERROR) {
                return dispatch(dispatchToReducer(Constants.ALL_FLIGHTS_FAILURE, response));
              }
              if (response && response.status === StatusCodes.OK) {
                allFlights.push({
                  routeId: secondRoute,
                  flights: response.data,
                });
                return dispatch(dispatchToReducer(Constants.ALL_FLIGHTS_SUCCESS, allFlights));
              }
              return dispatch(dispatchToReducer(Constants.ALL_FLIGHTS_FAILURE, response));
            })
            .catch(error => {
              console.error('Error occured: ', error);
              return dispatch(dispatchToReducer(Constants.ALL_FLIGHTS_FAILURE, error));
            });
        }
      })
      .catch(error => {
        console.error('Error occured: ', error);
        return dispatch(dispatchToReducer(Constants.ALL_FLIGHTS_FAILURE, error));
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/AllFlightsActions.js